function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-beautiful-dnd';
import Droppable from './Droppable';
import Draggable from './Draggable';
import '@nt/dds-style/core/dragdrop.css';
var DragDrop = /*#__PURE__*/function (_Component) {
  _inherits(DragDrop, _Component);
  var _super = _createSuper(DragDrop);
  function DragDrop(props, context) {
    var _this;
    _classCallCheck(this, DragDrop);
    _this = _super.call(this, props, context);
    _defineProperty(_assertThisInitialized(_this), "reorder", function (list, startIndex, endIndex) {
      var result = Array.from(list);
      var _result$splice = result.splice(startIndex, 1),
        _result$splice2 = _slicedToArray(_result$splice, 1),
        removed = _result$splice2[0];
      result.splice(endIndex, 0, removed);
      return result;
    });
    var items = _this.props.items;
    _this.itemsArray = Array.from({
      length: items.length
    }, function (v, k) {
      return k;
    }).map(function (k) {
      return {
        id: k,
        content: items[k]
      };
    });
    _this.state = {
      items: _this.itemsArray
    };
    _this.onDragEnd = _this.onDragEnd.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(DragDrop, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      if (this.props.items && this.props.items !== prevProps.items) {
        // Update the content for all of the current items in case of changes
        // but keep the order the same
        this.setState({
          items: this.state.items.map(function (stateItem) {
            return _objectSpread(_objectSpread({}, stateItem), {}, {
              content: _this2.props.items.find(function (propItem, index) {
                return index === stateItem.id;
              })
            });
          })
        });
      }
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(result) {
      var onDragEnd = this.props.onDragEnd;
      var items = this.state.items;
      // dropped outside the list
      if (!result.destination) {
        return;
      }
      var calcItems = this.reorder(items, result.source.index, result.destination.index);
      this.setState({
        items: calcItems
      });
      onDragEnd(result);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        droppableId = _this$props.droppableId,
        draggableId = _this$props.draggableId,
        direction = _this$props.direction,
        onDragStart = _this$props.onDragStart,
        onDragUpdate = _this$props.onDragUpdate,
        onBeforeDragStart = _this$props.onBeforeDragStart;
      var items = this.state.items;
      return /*#__PURE__*/React.createElement(DragDropContext, {
        onDragStart: onDragStart,
        onDragEnd: this.onDragEnd,
        onBeforeDragStart: onBeforeDragStart,
        onDragUpdate: onDragUpdate
      }, /*#__PURE__*/React.createElement(Droppable, {
        droppableId: droppableId,
        className: className,
        direction: direction
      }, items.map(function (item, index) {
        return /*#__PURE__*/React.createElement(Draggable, {
          key: "".concat(draggableId, "-").concat(item.id),
          draggableId: "".concat(draggableId, "-").concat(item.id),
          index: index
        }, item.content);
      })));
    }
  }]);
  return DragDrop;
}(Component);
_defineProperty(DragDrop, "propTypes", {
  className: PropTypes.string,
  droppableId: PropTypes.string.isRequired,
  draggableId: PropTypes.string.isRequired,
  items: PropTypes.array,
  direction: PropTypes.oneOf(['vertical', 'horizontal']),
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func,
  onBeforeDragStart: PropTypes.func,
  onDragUpdate: PropTypes.func
});
_defineProperty(DragDrop, "defaultProps", {
  direction: 'vertical'
});
export { DragDrop as default };
DragDrop.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onDragEnd",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "result",
      "type": null
    }],
    "returns": null
  }, {
    "name": "reorder",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "list",
      "type": null
    }, {
      "name": "startIndex",
      "type": null
    }, {
      "name": "endIndex",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "DragDrop",
  "props": {
    "direction": {
      "defaultValue": {
        "value": "'vertical'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'vertical'",
          "computed": false
        }, {
          "value": "'horizontal'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "droppableId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "draggableId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "items": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "onDragStart": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDragEnd": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onBeforeDragStart": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDragUpdate": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};